import React from 'react';
import { motion } from "motion/react";

const SchedulesSkeleton: React.FC = () => {
  return (
    <motion.div
      key="skeleton"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 0.3 }}
    >
      <div className="text-center mb-10">
        <h2 className="text-4xl font-serif font-medium text-white text-center mb-10">
          Book Your Date
        </h2>
      </div>
      <div className="space-y-4">
        {[1, 2, 3].map((index) => (
          <motion.div
            key={index}
            className="flex flex-col sm:flex-row items-start sm:items-center p-4 border-b border-gray-800/50 rounded-lg"
            initial={{ opacity: 0, y: 10 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: index * 0.1 }}
          >
            <div className="flex-shrink-0 text-center w-full sm:w-20 mb-3 sm:mb-0">
              <div className="h-4 w-16 bg-gray-800 rounded mx-auto mb-2 animate-pulse" />
              <div className="h-12 w-12 bg-gray-800 rounded mx-auto animate-pulse" />
            </div>
            <div className="flex-1 sm:ml-6 mb-3 sm:mb-0 space-y-2">
              <div className="h-5 w-32 bg-gray-800 rounded animate-pulse" />
              <div className="h-4 w-48 bg-gray-800 rounded animate-pulse" />
            </div>
            <div className="flex flex-col sm:flex-row gap-3 w-full sm:w-auto">
              <div className="h-10 w-32 bg-gray-800 rounded-full animate-pulse" />
              <div className="h-10 w-32 bg-gray-800 rounded-full animate-pulse" />
            </div>
          </motion.div>
        ))}
      </div>
    </motion.div>
  );
};

export default SchedulesSkeleton;
